import API from "../../helpers/API";
import {
  SHOW_LOADER,
  HIDE_LOADER,
  SET_PRESENT_ABSENT_COUNTS,
  GET_STATISTICALDATA,
  GET_POST_CRITERIA,
  GET_PRE_EXAM_ADVER,
  GET_MAIN_EXAM_ADVER,
} from "../../common/constants/ActionTypes";
import {
  GETSTATISTICALPREABSREPORT,
  GET_MAINEXAMRESULT_ADVERTISEMENT,
  GET_POST_CRITERIA_STATISTICS,
  GET_PREEXAMRESULT_ADVERTISEMENT,
  GET_STATISTICAL_DATA,
} from "../../common/constants/endpoints";
import { toastr } from "react-redux-toastr";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";

export const showLoader = () => {
  return (dispatch) => {
    dispatch({
      type: SHOW_LOADER,
    });
  };
};

export const hideLoader = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_LOADER,
    });
  };
};

export const getPresentAbsentData = (advertNo, examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GETSTATISTICALPREABSREPORT}/?advertisementid=${advertNo}&examid=${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_PRESENT_ABSENT_COUNTS,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getStatisticsData = (advertNo, examId, setPrintFlag) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_STATISTICAL_DATA}/?advertisementid=${advertNo}&examid=${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_STATISTICALDATA,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      setPrintFlag(true)
      handleError(error);
    }
  };
};

export const getPostCriteriaStatisticsData = (
  advertNo,
  examId,
  postcriteriaid,
  setPrePrintFlag

) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_POST_CRITERIA_STATISTICS}/?advertisementid=${advertNo}&examid=${examId}&postcriteriaid=${postcriteriaid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_POST_CRITERIA,
        });
        if (response.data.message == "No records found") {
          // toastr.error(response.data.message);
          setPrePrintFlag(true)
        } else {
          setPrePrintFlag(false)
        }
        handleResponseMessage(response);
      }

      // dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      setPrePrintFlag(true)
      handleError(error);
    }
  };
};

export const getpreExamResultAdvertByYearId = (yearId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_PREEXAMRESULT_ADVERTISEMENT}/?year=${yearId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_PRE_EXAM_ADVER,
        });
      }

      // dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const getmainExamResultAdvertByYearId = (yearId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_MAINEXAMRESULT_ADVERTISEMENT}/?year=${yearId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_MAIN_EXAM_ADVER,
        });
      }

      // dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


